const SUCCESS = 'SUCCESS'
const FAILURE = 'FAILURE'
const PENDING = 'PENDING'
const INVALID = 'INVALID'

const DONATION_STATUSES = { SUCCESS: SUCCESS, FAILURE: FAILURE, PENDING: PENDING, INVALID: INVALID }
const DONATION_STATUS_CHOICES = [
  {
    name: 'Success',
    id: SUCCESS,
  },
  {
    name: 'Failure',
    id: FAILURE,
  },
  {
    name: 'Pending',
    id: PENDING,
  },
  {
    name: 'Invalid',
    id: INVALID,
  },
]

export default {
  SUCCESS,
  FAILURE,
  PENDING,
  INVALID,
  DONATION_STATUSES,
  DONATION_STATUS_CHOICES,
}
